module.exports = __webpack_public_path__ + "media/images/icon/icons8-Maximize Window-ce15ffa50fdc52db2f0279baa901d805.png";